export { default } from './content'
export * from './content'
